/* eslint-disable */
import { Component, OnInit, ViewChild } from '@angular/core';
import { IonSlides, ModalController } from '@ionic/angular';
import { LoggerService } from 'src/app/services/logger.service';

@Component({
  selector: 'app-add-stops-tutorial',
  templateUrl: './add-stops-tutorial.page.html',
  styleUrls: ['./add-stops-tutorial.page.scss']
})
export class AddStopsTutorialPage implements OnInit {
  @ViewChild('slides', { static: false }) slides: IonSlides;
  slideIndex = 0;
  slideOpts: any = {};

  constructor(
    private modalCtrl: ModalController,
    private logger: LoggerService
  ) {}

  updateSlideIndex() {
    Promise.all([this.slides.getActiveIndex()]).then((res) => {
      this.slideIndex = res[0];
    });
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  slidePrev() {
    this.slides.slidePrev();
    this.updateSlideIndex();
  }

  async slideNext() {
    const isEnd = await this.slides.isEnd();
    if (isEnd) {
      this.dismiss();
      return;
    }

    this.slides.slideNext();
    this.updateSlideIndex();
  }

  ionViewWillEnter() {
    this.slides.update();
  }

  ngOnInit() {}
}
